export default __webpack_public_path__ + "static/ProximaNova-Regular-7bc9ce404c297c24f2104c18ec4a8526.otf";